// ui/src/utils/formatDateRus.js
export function formatDateRus(iso) {
  if (!iso) return "";
  const [year, month, day] = iso.split("-");
  const months = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];
  const m = months[parseInt(month, 10) - 1] || "";
  const dNum = parseInt(day, 10);
  return `${dNum} ${m} ${year}`;
}
